<div class="row">
    <div class="col-12 text-center">
        <div class="symbol-alert-icon symbol-alert-error animate" *ngIf="typeAlert === 'error'">
            <span class="symbol-alert-x-mark">
                <span class="symbol-alert-line symbol-alert-left animateXLeft"></span>
                <span class="symbol-alert-line symbol-alert-right animateXRight"></span>
            </span>
            <div class="symbol-alert-placeholder"></div>
            <div class="symbol-alert-fix"></div>
        </div>
        <!-- warning -->
        <div class="symbol-alert-icon symbol-alert-warning scaleWarning" *ngIf="typeAlert === 'warning'">
            <span class="symbol-alert-body pulseWarningIns"></span>
            <span class="symbol-alert-dot pulseWarningIns"></span>
        </div>
        <!-- info -->
        <div class="symbol-alert-icon symbol-alert-info scaleWarning" *ngIf="typeAlert === 'info'">
            <span class="symbol-alert-dot pulseInfoIns"></span>
            <span class="symbol-alert-body pulseInfoIns"></span>
        </div>
        <!-- success -->
        <div class="symbol-alert-icon symbol-alert-success animate" *ngIf="typeAlert === 'success'">
            <span class="symbol-alert-line symbol-alert-tip animateSuccessTip"></span>
            <span class="symbol-alert-line symbol-alert-long animateSuccessLong"></span>
            <div class="symbol-alert-placeholder"></div>
            <div class="symbol-alert-fix"></div>
        </div>
    </div>
</div>
<!-- error -->